import { css } from 'styled-components';
import { FontFamily } from '../constants';

const font = fontFamily => (fontSize, letterSpacing, lineHeight) => {
    return css`
        font-family: ${fontFamily};
        font-size: ${fontSize}px;
        line-height: ${lineHeight}px;
        letter-spacing: ${letterSpacing}%;
    `;
};

export const sharpSansMedium = font(FontFamily.SharpSansMedium);
export const sharpSansSemibold = font(FontFamily.SharpSansSemibold);
export const sharpSansBold = font(FontFamily.SharpSansBold);
